import { createContext } from 'react';

const StoreBrandContext = createContext(null);

export { StoreBrandContext };
